module.exports = __webpack_public_path__ + "static/media/ieee_bd2.bdd8b972.jpg";